import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme.js';
import { connect } from 'react-redux';

import { request, guid, mapStateToProps, mapDispatchToProps } from '../../utils';
import { fetchArticleBySlug } from '../../actions/content';

import Body from '../../components/Body';
import Header from '../../components/Header';
import CompanyLogo from '../../components/CompanyLogo';
import Paragraph from '../../components/Paragraph';

class ErrorView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Body
        title="404 - Sniffers"
        history={this.props.history}
        style={styles.body}
        player={this.props.player}
        search={this.props.search}
        player={this.props.player}
        dispatch={this.props.dispatch}>
        <Header content={this.props.content} dispatch={this.props.dispatch} />
        <div className={css(styles.container)}>
          <div className={css(styles.title)}>Damn. We couldn't find that.</div>
        </div>
      </Body>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorView);

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  body: {
    display: 'flex',
    backgroundColor: Theme.black,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    color: Theme.white,
    fontSize: 40,
    fontFamily: Theme.fontFamily,
    fontWeight: 900
  }
});



// WEBPACK FOOTER //
// ./src/views/ErrorView/index.js